export enum FirstPair {
    No = "No",
    Yes = "Yes"
}
